import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { REVIEW_TYPE_OF_PROVIDER, REVIEW_TYPE_OF_CUSTOMER, propTypes } from '../../util/types';
import { ensureCurrentUser, ensureUser } from '../../util/data';
import { withViewport } from '../../util/contextHelpers';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';

import {
  Page,
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperSideNav,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  Footer,
  AvatarMedium,
  NamedLink,
  ListingCard,
  PrimaryButton,
  Reviews,
  ButtonTabNavHorizontal,
} from '../../components';
import { TopbarContainer, NotFoundPage } from '../../containers';
import config from '../../config';
import { Grid } from '@material-ui/core'
import CheckMark from '../../assets/icons/006_Profil/check_mark.svg'
import CheckMarkGreen from '../../assets/icons/006_Profil/check_mark_green.svg'
import Star from '../../assets/icons/006_Profil/star_grey.svg'
import StarRed from '../../assets/icons/006_Profil/star_red.svg'

import css from './ProfilePage.module.css';

const MAX_MOBILE_SCREEN_WIDTH = 768;

export class ProfilePageComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // keep track of which reviews tab to show in desktop viewport
      showReviewsType: REVIEW_TYPE_OF_PROVIDER,
    };

    this.showOfProviderReviews = this.showOfProviderReviews.bind(this);
    this.showOfCustomerReviews = this.showOfCustomerReviews.bind(this);
  }

  showOfProviderReviews() {
    this.setState({
      showReviewsType: REVIEW_TYPE_OF_PROVIDER,
    });
  }

  showOfCustomerReviews() {
    this.setState({
      showReviewsType: REVIEW_TYPE_OF_CUSTOMER,
    });
  }

  render() {
    const {
      scrollingDisabled,
      currentUser,
      user,
      userShowError,
      queryListingsError,
      listings,
      reviews,
      queryReviewsError,
      viewport,
      intl,
    } = this.props;


    const ensuredCurrentUser = ensureCurrentUser(currentUser);
    const profileUser = ensureUser(user);

    try {
      const isCurrentUser =
        ensuredCurrentUser.id && profileUser.id && ensuredCurrentUser.id.uuid === profileUser.id.uuid;
      const displayName = profileUser && profileUser.attributes ? profileUser.attributes.profile.displayName : "";
      const bio = profileUser && profileUser.attributes && profileUser.attributes.profile.bio;
      const isOwner = profileUser && profileUser.attributes.profile.publicData && profileUser.attributes.profile.publicData.isOwner;
      const isStripeIdVerified = profileUser && profileUser.attributes.profile.publicData && profileUser.attributes.profile.publicData.isStripeIdVerified;
      const isAddressVerified = profileUser && profileUser.attributes.profile.publicData && profileUser.attributes.profile.publicData.isAddressVerified;
      const ownerIsStripeIdVerified = profileUser && profileUser.attributes.profile.publicData && profileUser.attributes.profile.publicData.isStripeIdVerified;
      const ownerIsAddressVerified = profileUser && profileUser.attributes.profile.publicData && profileUser.attributes.profile.publicData.isAddressVerified;

      const hasBio = !!bio;
      const hasListings = listings.length > 0;
      const isMobileLayout = viewport.width < MAX_MOBILE_SCREEN_WIDTH;
      const isEmailVerified = profileUser ? !!profileUser.attributes.emailVerified : false;
      const createdAt = profileUser && profileUser.attributes.createdAt ? profileUser.attributes.createdAt.getFullYear() : null;
      const stripeConnected = profileUser ? !!profileUser.attributes.stripeConnected : false;

      const editLinkMobile = isCurrentUser ? (
        <NamedLink className={css.editLinkMobile} name="ProfileSettingsPage">
          <FormattedMessage id="ProfilePage.editProfileLinkMobile" />
        </NamedLink>
      ) : null;
      const editLinkDesktop = isCurrentUser ? (
        <>
          {
            isOwner && <p className={css.editLinkDesktop}>
              <img src={isStripeIdVerified ? CheckMarkGreen : CheckMark} height="13" alt="check" />&nbsp;
              {isStripeIdVerified ?
                <FormattedMessage id="ProfilePage.idVerified" /> :
                <FormattedMessage id="ProfilePage.idNotVerified" />}
            </p>
          }
          { /*
        <p className={css.editLinkDesktop}>
          <img src={isEmailVerified ? CheckMarkGreen : CheckMark} height="13" alt="check" />&nbsp;
          {isEmailVerified ?
            <FormattedMessage id="ProfilePage.emailVerified" /> :
            <FormattedMessage id="ProfilePage.emailNotVerified" />}
        </p>
        */
          }
          {
            isOwner && <p className={css.editLinkDesktop}>
              <img src={isAddressVerified ? CheckMarkGreen : CheckMark} height="13" alt="check" />&nbsp;
              {isAddressVerified ?
                <FormattedMessage id="ProfilePage.addressVerified" /> :
                <FormattedMessage id="ProfilePage.addressNotVerified" />}
            </p>
          }

          <p className={css.editLinkDesktop}>
            <FormattedMessage id="ProfilePage.memberSince" values={{ year: createdAt }} />
          </p>
          {/* <p className={css.editLinkDesktop}>
      <img src={StarRed} height="13" alt="check" />&nbsp;
      <img src={StarRed} height="13" alt="check" />&nbsp;
      <img src={Star} height="13" alt="check" />&nbsp;
      </p> */}
          <div style={{ marginTop: 10 }}>
            <NamedLink className={css.editLinkDesktop} style={{ textDecoration: 'underline' }} name="ProfileSettingsPage">
              <FormattedMessage id="ProfilePage.editProfileLinkDesktop" />
            </NamedLink>
          </div>

        </>
      ) : (<>
        {
          isOwner && <p className={css.editLinkDesktop}>
            <img src={isStripeIdVerified ? CheckMarkGreen : CheckMark} height="13" alt="check" />&nbsp;
            {isStripeIdVerified ?
              <FormattedMessage id="ProfilePage.idVerified" /> :
              <FormattedMessage id="ProfilePage.idNotVerified" />}
          </p>
        }
        { /*
      <p className={css.editLinkDesktop}>
        <img src={isEmailVerified ? CheckMarkGreen : CheckMark} height="13" alt="check" />&nbsp;
        {isEmailVerified ?
          <FormattedMessage id="ProfilePage.emailVerified" /> :
          <FormattedMessage id="ProfilePage.emailNotVerified" />}
        </p>
        */}
        {
          isOwner && <p className={css.editLinkDesktop}>
            <img src={isAddressVerified ? CheckMarkGreen : CheckMark} height="13" alt="check" />&nbsp;
            {isAddressVerified ?
              <FormattedMessage id="ProfilePage.addressVerified" /> :
              <FormattedMessage id="ProfilePage.addressNotVerified" />}
          </p>
        }

        <p className={css.editLinkDesktop}>
          <FormattedMessage id="ProfilePage.memberSince" values={{ year: createdAt }} />
        </p>
      </>);



      const editLinkMobile2 = isCurrentUser ? (
        <>
          {
            isOwner && <p className={css.editLinkMobile}>
              <img src={isStripeIdVerified ? CheckMarkGreen : CheckMark} height="13" alt="check" />&nbsp;
              {isStripeIdVerified ?
                <FormattedMessage id="ProfilePage.idVerified" /> :
                <FormattedMessage id="ProfilePage.idNotVerified" />}
            </p>
          }
          {/*
        <p className={css.editLinkMobile}>
          <img src={isEmailVerified ? CheckMarkGreen : CheckMark} height="13" alt="check" />&nbsp;
          {isEmailVerified ?
            <FormattedMessage id="ProfilePage.emailVerified" /> :
            <FormattedMessage id="ProfilePage.emailNotVerified" />}
        </p>
          */}
          {
            isOwner && <p className={css.editLinkMobile}>
              <img src={isAddressVerified ? CheckMarkGreen : CheckMark} height="13" alt="check" />&nbsp;
              {isAddressVerified ?
                <FormattedMessage id="ProfilePage.addressVerified" /> :
                <FormattedMessage id="ProfilePage.addressNotVerified" />}
            </p>
          }

          <p className={css.editLinkMobile}>
            <FormattedMessage id="ProfilePage.memberSince" values={{ year: createdAt }} />
          </p>

        </>
      ) : (<>
        {
          <p className={css.editLinkMobile}>
            <img src={ownerIsStripeIdVerified ? CheckMarkGreen : CheckMark} height="13" alt="check" />&nbsp;
            {ownerIsStripeIdVerified ?
              <FormattedMessage id="ProfilePage.idVerified" /> :
              <FormattedMessage id="ProfilePage.idNotVerified" />}
          </p>
        }
        {/*
      <p className={css.editLinkMobile}>
        <img src={isEmailVerified ? CheckMarkGreen : CheckMark} height="13" alt="check" />&nbsp;
        {isEmailVerified ?
          <FormattedMessage id="ProfilePage.emailVerified" /> :
          <FormattedMessage id="ProfilePage.emailNotVerified" />}
        </p>
        */}
        {
          <p className={css.editLinkMobile}>
            <img src={ownerIsAddressVerified ? CheckMarkGreen : CheckMark} height="13" alt="check" />&nbsp;
            {ownerIsAddressVerified ?
              <FormattedMessage id="ProfilePage.addressVerified" /> :
              <FormattedMessage id="ProfilePage.addressNotVerified" />}
          </p>
        }

        <p className={css.editLinkMobile}>
          <FormattedMessage id="ProfilePage.memberSince" values={{ year: createdAt }} />
        </p>
      </>);

      const asideContent = (
        <>
          <div className={css.asideContent}>
            <h1 className={css.mobileHeading}>
              {displayName ? (
                <FormattedMessage id="ProfilePage.mobileHeading" values={{ name: displayName }} />
              ) : null}
              {editLinkMobile}
            </h1>

            <div className={css.editLinkDesktopWrapper}>
              {editLinkDesktop}
            </div>



          </div>
        </>
      );

      const listingsContainerClasses = classNames(css.listingsContainer, {
        [css.withBioMissingAbove]: !hasBio,
      });

      const reviewsError = (
        <p className={css.error}>
          <FormattedMessage id="ProfilePage.loadingReviewsFailed" />
        </p>
      );

      const mobileReviews = (
        <div className={css.mobileReviews}>
          <h2 className={css.mobileReviewsTitle}>
            Commentaires
          </h2>
          {queryReviewsError ? reviewsError : null}
          <Reviews reviews={reviews} />
        </div>
      );

      const desktopReviews = (
        <div className={css.desktopReviews}>
          <h2>Commentaires</h2>
          {queryReviewsError ? reviewsError : null}
          <Reviews reviews={reviews} />
        </div>
      );

      const mainContent = (
        <div>
          <h2 className={css.desktopHeading}>
            <FormattedMessage id="ProfilePage.desktopHeading" values={{ name: displayName }} />
          </h2>
          {hasBio ? <p className={css.bio}>{bio}</p> : null}
          {hasListings ? (
            <div className={listingsContainerClasses}>
              <h2 className={css.listingsTitle}>
                <FormattedMessage
                  id="ProfilePage.listingsTitle"
                  values={{ count: listings.length }}
                />
              </h2>
              <Grid container>
                {listings.map(l => (
                  <Grid item xs={12} sm={6} md={4} key={l.id.uuid}>
                    <ListingCard listing={l} />
                  </Grid>
                ))}
              </Grid>
            </div>
          ) : null}
          {isMobileLayout ? mobileReviews : desktopReviews}
        </div>
      );

      let content;

      if (userShowError && userShowError.status === 404) {
        return <NotFoundPage />;
      } else if (userShowError || queryListingsError) {
        content = (
          <p className={css.error}>
            <FormattedMessage id="ProfilePage.loadingDataFailed" />
          </p>
        );
      } else {
        content = mainContent;
      }

      const schemaTitle = intl.formatMessage(
        {
          id: 'ProfilePage.schemaTitle',
        },
        {
          name: displayName,
          siteTitle: config.siteTitle,
        }
      );
      return (
        <Page
          scrollingDisabled={scrollingDisabled}
          title={schemaTitle}
          schema={{
            '@context': 'http://schema.org',
            '@type': 'ProfilePage',
            name: schemaTitle,
          }}
        >
          <LayoutSideNavigation className={css.sideNavContainer}>
            <LayoutWrapperTopbar>
              <TopbarContainer currentPage="ProfilePage" />
            </LayoutWrapperTopbar>

            <LayoutWrapperSideNav className={css.aside}>
              <AvatarMedium className={css.avatar} user={user} disableProfileLink />
              {asideContent}
            </LayoutWrapperSideNav>

            <LayoutWrapperMain><>
              <div className={css.editLinkMobileWrapper}>
                {editLinkMobile2}
              </div></>{content}</LayoutWrapperMain>
            <LayoutWrapperFooter>
              <Footer />
            </LayoutWrapperFooter>
          </LayoutSideNavigation>
        </Page>
      );
    } catch (err) {
      console.log("ERROR PROFILE PAGE", err);
      return <></>;
    }
  }
}

ProfilePageComponent.defaultProps = {
  currentUser: null,
  user: null,
  userShowError: null,
  queryListingsError: null,
  reviews: [],
  queryReviewsError: null,
};

const { bool, arrayOf, number, shape } = PropTypes;

ProfilePageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  currentUser: propTypes.currentUser,
  user: propTypes.user,
  userShowError: propTypes.error,
  queryListingsError: propTypes.error,
  listings: arrayOf(propTypes.listing).isRequired,
  reviews: arrayOf(propTypes.review),
  queryReviewsError: propTypes.error,

  // form withViewport
  viewport: shape({
    width: number.isRequired,
    height: number.isRequired,
  }).isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const {
    userId,
    userShowError,
    queryListingsError,
    userListingRefs,
    reviews,
    queryReviewsError,
  } = state.ProfilePage;
  const userMatches = getMarketplaceEntities(state, [{ type: 'user', id: userId }]);
  const user = userMatches.length === 1 ? userMatches[0] : null;
  const listings = getMarketplaceEntities(state, userListingRefs);
  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
    user,
    userShowError,
    queryListingsError,
    listings,
    reviews,
    queryReviewsError,
  };
};

const ProfilePage = compose(
  connect(mapStateToProps),
  withViewport,
  injectIntl
)(ProfilePageComponent);

export default ProfilePage;
